/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsOfUseItem
 */
export interface TermsOfUseItem {
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseItem
     */
    originalFileName: string;
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseItem
     */
    filePath: string;
    /**
     * 
     * @type {number}
     * @memberof TermsOfUseItem
     */
    version: number;
}

/**
 * Check if a given object implements the TermsOfUseItem interface.
 */
export function instanceOfTermsOfUseItem(value: object): value is TermsOfUseItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('originalFileName' in value) || value['originalFileName'] === undefined) return false;
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function TermsOfUseItemFromJSON(json: any): TermsOfUseItem {
    return TermsOfUseItemFromJSONTyped(json, false);
}

export function TermsOfUseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsOfUseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'originalFileName': json['originalFileName'],
        'filePath': json['filePath'],
        'version': json['version'],
    };
}

export function TermsOfUseItemToJSON(json: any): TermsOfUseItem {
    return TermsOfUseItemToJSONTyped(json, false);
}

export function TermsOfUseItemToJSONTyped(value?: TermsOfUseItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'originalFileName': value['originalFileName'],
        'filePath': value['filePath'],
        'version': value['version'],
    };
}

